<template>
  <div class="agreement-checkbox">
    <el-checkbox
      :model-value="modelValue"
      @update:model-value="handleToggle"
      size="small"
    >
      <span class="agreement-text">
        {{ $t('auth.agreement.prefix') }}
        <a
          href="/privacy"
          target="_blank"
          class="agreement-link"
          @click.stop
        >
          {{ $t('auth.agreement.privacy') }}
        </a>
        {{ $t('auth.agreement.and') }}
        <a
          href="/terms"
          target="_blank"
          class="agreement-link"
          @click.stop
        >
          {{ $t('auth.agreement.terms') }}
        </a>
      </span>
    </el-checkbox>
  </div>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const handleToggle = (value: boolean) => {
  emit('update:modelValue', value)
}
</script>

<style scoped lang="scss">
.agreement-checkbox {
  display: inline-flex;
  align-items: flex-start;
  
  .agreement-text {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.5;
  }

  .agreement-link {
    color: #4A90E2;  // 使用品牌科技蓝
    text-decoration: none;
    transition: color 0.2s;
    font-weight: 500;

    &:hover {
      color: #50E3C2;  // 悬停时使用品牌青色
      text-decoration: underline;
    }
  }

  :deep(.el-checkbox) {
    align-items: flex-start;
    
    .el-checkbox__input {
      margin-top: 2px;
      
      .el-checkbox__inner {
        border-radius: 3px;
      }
    }
    
    .el-checkbox__label {
      padding-left: 8px;
    }
  }
}
</style>